export const capitalize = (text) => {
  if (typeof text !== 'string') return '';

  return text.charAt(0).toUpperCase() + text.slice(1);
};

export const sliceText = (text, quantityCharacters) => {
  if (!text) return '';

  if (text > quantityCharacters) {
    const textSliced = quantityCharacters;

    return `${textSliced}...`;
  }

  return text;
};

function isPlural(quantity, exception) {
  const hasException = exception === 0 || exception;

  if ((hasException && quantity === exception) || quantity > 1) {
    return true;
  }

  return false;
}

export function pluralizer(quantity, exception) {
  return isPlural(quantity, exception) ? 's' : '';
}

export const secondsFormatter = (secondsToConvert = 0) => {
  const date = new Date(0);

  date.setSeconds(secondsToConvert);

  const result = date.toISOString().substring(14, 19);

  return result;
};
